module.exports = __webpack_public_path__ + "media/images/icon__settings-690e03bd3593572e01c2c3e7eb516b21.png";